import template from './message.create.html';
import controller from './message.create.controller';
import './message.create.scss';

let messageCreateComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default messageCreateComponent;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/create/message.create.component.js